"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLanguage;

var _useLocalizedStrings = _interopRequireDefault(require("./internal/useLocalizedStrings"));

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useLanguage(options) {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      language = _useWebChatUIContext.language;

  var localizedStrings = (0, _useLocalizedStrings.default)();

  if (options === 'speech') {
    return [localizedStrings.SPEECH_LANGUAGE || language];
  }

  return [language];
}